import React from 'react';

import { Container, Paragraph } from './styles';
import Header from '../../components/HeaderMenuContent';
import Aprovado from '../../assets/aprovado.png';
import {Button} from "react-bootstrap";
import {useNavigate} from "react-router";

export default function OrderPlacedSuccessfully() {

    const navigate = useNavigate()
    function RoutesHome () {
        navigate('/loja')
    }

    return (
        <>
            <Header />
            <Container>
                <Paragraph>
                    <img src={Aprovado } alt="Order" />
                    <p className="title">Pedido feito com sucesso!</p>
                    <p className="order">Pedido n° 505897 </p>
                    <p className="color">Já estamos processando seu pagamento. Logo logo, te enviamos um e-mail! </p>
                </Paragraph>
                <Button onClick={RoutesHome} className="btn-default-wl">VOLTAR PARA HOME</Button>
            </Container>
        </>
    )

}
